import { render, staticRenderFns } from "./secondaryButton.vue?vue&type=template&id=64539f24&scoped=true"
import script from "./secondaryButton.vue?vue&type=script&lang=js"
export * from "./secondaryButton.vue?vue&type=script&lang=js"
import style0 from "./secondaryButton.vue?vue&type=style&index=0&id=64539f24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64539f24",
  null
  
)

export default component.exports